export * from './unauthorized-page.component';
